import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { CategoriesResolver } from './resolvers/categories.resolver';
import { SearchResultsComponent } from './pages/search-results/search-results.component';
import { CategoryManagementComponent } from './components/category-management/category-management.component';
import { OrganizationManagementComponent } from './components/organization-management/organization-management.component';
import { OrganizationsResolver } from './resolvers/organizations.resolver';
import { UsersResolver } from './resolvers/users.resolver';
import { EventManagementComponent } from './components/event-management/event-management.component';
import { EventsResolver } from './resolvers/events.resolver';
import { UnwrappedCategoriesResolver } from './resolvers/unwrapped-categories.resolver';
import { BrowseCategoriesComponent } from './pages/browse-categories/browse-categories.component';
import { BrowseOrganizationsComponent } from './components/browse-organizations/browse-organizations.component';
import { EventSinglePageComponent } from './pages/event-single-page/event-single-page.component';
import { SingleEventResolver } from './resolvers/single-event.resolver';
import { EventRegistrationComponent } from './components/event-registration/event-registration.component';
import { EventRegistrationFormComponent } from './components/event-registration-form/event-registration-form.component';
import { EventRegistrationSuccessComponent } from './components/event-registration-success/event-registration-success.component';
import { EventRegistrationFailComponent } from './components/event-registration-fail/event-registration-fail.component';
import { LandingEventsResolver } from './resolvers/landing-events.resolver';
import { LandingOrganizationsResolver } from './resolvers/landing-organizations.resolver';
import { LandingCategoriesResolver } from './resolvers/landing-categories.resolver';
import { MyCalendarComponent } from './pages/my-calendar/my-calendar.component';
import { CanAccessRoute } from './services/canActivate.service';
import { MySettingsComponent } from './pages/my-settings/my-settings.component';
import { CreateEventComponent } from './components/event-management/create-event/create-event.component';
import { CreateEventLegacyComponent } from './components/event-management/create-event/create-event-legacy.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { ROUTES } from './constants/routes';
import { CategoriesWithEventsResolver } from './resolvers/categories-with-events.resolver';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    resolve: {
      categories: LandingCategoriesResolver,
      organizations: LandingOrganizationsResolver,
      events: LandingEventsResolver,
    },
  },
  {
    path: ROUTES.RESULTS,
    component: SearchResultsComponent,
    resolve: {
      categories: CategoriesResolver,
      organizations: OrganizationsResolver,
    },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'event/:event_id',
    component: EventSinglePageComponent,
  },
  {
    path: 'browse-categories/:category_id',
    component: BrowseCategoriesComponent,
    resolve: {
      categories: CategoriesWithEventsResolver,
    },
  },
  {
    path: 'browse-categories',
    component: BrowseCategoriesComponent,
    resolve: {
      categories: CategoriesWithEventsResolver,
    },
  },
  {
    path: 'event-registration/:event_id',
    component: EventRegistrationComponent,
    resolve: {
      event: SingleEventResolver,
    },
    children: [
      {
        path: 'form',
        component: EventRegistrationFormComponent,
      },
      {
        path: 'success',
        component: EventRegistrationSuccessComponent,
      },
      {
        path: 'fail',
        component: EventRegistrationFailComponent,
      },
    ],
    canActivate: [CanAccessRoute],
  },
  {
    path: 'browse-organizations',
    component: BrowseOrganizationsComponent,
    resolve: {
      organizations: OrganizationsResolver,
    },
  },
  {
    path: ROUTES.CMS_CATEGORY_MANAGEMENT,
    component: CategoryManagementComponent,
    resolve: {
      categories: UnwrappedCategoriesResolver,
    },
    canActivate: [CanAccessRoute],
  },
  {
    path: ROUTES.CMS_ORGANIZATION_MANAGEMENT,
    component: OrganizationManagementComponent,
    resolve: {
      categories: UnwrappedCategoriesResolver,
      organizations: OrganizationsResolver,
      users: UsersResolver,
    },
    canActivate: [CanAccessRoute],
  },
  {
    path: ROUTES.CMS_EVENT_MANAGEMENT,
    resolve: {
      categories: UnwrappedCategoriesResolver,
      organizations: OrganizationsResolver,
      events: EventsResolver,
    },
    children: [
      {
        path: '',
        component: EventManagementComponent,
      },
      {
        path: 'modify',
        component: CreateEventLegacyComponent,
      },
      {
        path: 'modify/:event_id',
        component: CreateEventLegacyComponent,
      },
      {
        path: 'v2/modify',
        component: CreateEventComponent,
      },
      {
        path: 'v2/modify/:event_id',
        component: CreateEventComponent,
      },
    ],
    canActivate: [CanAccessRoute],
  },
  {
    path: ROUTES.MY_CALENDAR,
    resolve: {
      categories: CategoriesResolver,
    },
    component: MyCalendarComponent,
    canActivate: [CanAccessRoute],
  },
  {
    path: ROUTES.MY_ACCOUNT,
    component: MySettingsComponent,
    canActivate: [CanAccessRoute],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: ROUTES.CONTACT_US,
    component: ContactUsComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
  providers: [CanAccessRoute],
})
export class AppRoutingModule {}
